import { useEffect, useState } from 'react';

import { Species } from '../../../api/fishrules/getSpeciesAtLocation';
import { getSpeciesById } from '../../../api/fishrules/getSpeciesById';
import { reportMykissError } from '../../errorHandling';

interface Result {
  isLoading: boolean;
  species?: Species;
}

interface Params {
  fishrulesSpeciesId: number;
}

export function useSpeciesById(params: Params): Result {
  const [isLoading, setIsLoading] = useState(true);
  const [species, setSpecies] = useState<Species>();

  const fishrulesSpeciesId = params.fishrulesSpeciesId;

  useEffect(() => {
    const controller = new AbortController();
    setIsLoading(true);

    if (fishrulesSpeciesId !== undefined) {
      getSpeciesById({ fishrulesSpeciesId }, controller.signal)
        .then(({ results, success, message }) => {
          if (success && results.length) {
            setSpecies(results[0]);
          } else {
            setSpecies(undefined);
          }
          setIsLoading(false);
          if (!success && message) {
            reportMykissError(new Error(message));
          }
        })
        .catch(error => {
          if (error.name !== 'AbortError') {
            reportMykissError(error);
          }
          setIsLoading(false);
        });
    }

    return () => {
      controller.abort();
    };
  }, [fishrulesSpeciesId]);

  return { isLoading, species };
}
